import { useCallback, useState } from 'react'
import { useMounted } from '../../../Hooks/useMounted'
import { useAppDispatch } from '../../../Hooks/useAppDispatch'
import { ChargeCodesActions } from '../StoreAdapter'
import { ChargeCodeSchema } from '../../../Schema/ChargeCodeSchema'
import { ServiceLocator } from '../../../Services/ServiceLocator'
import { ChargeCodesAPI } from '../../../Services/API/ChargeCodesAPI'

export const useDeleteChargeCode = () => {
  const dispatch = useAppDispatch()
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const deleteChargeCode = useCallback(
    async (schemaId: string): Promise<ChargeCodeSchema> => {
      setProcessing(true)
      return ServiceLocator.resolve(ChargeCodesAPI)
        .deleteEntity(schemaId)
        .then((schema) => {
          dispatch(ChargeCodesActions.removeOne(schemaId))
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(null)
          }
          return schema
        })
        .catch((err) => {
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(err?.response?.data?.errorMessage)
            throw err
          }
          return null
        })
    },
    [dispatch, mounted],
  )

  return {
    processing,
    error,
    errorMessage,
    deleteChargeCode,
  }
}
